import {PeachyLogo} from '../../../global/assets/PeachyLogo/PeachyLogo'
import {Header} from '../Header'
import styles from './LoginHeader.module.css'

export function LoginHeader() {
    return <Header class={styles.header}>
        <PeachyLogo/>
    </Header>
}
